export const ScheduleFrequency = {
  DAY: "DAY",
  WEEK: "WEEK",
  TWOWEEK: "TWOWEEK",
  MONTH: "MONTH",
  QUARTER: "QUARTER",
} as const;

export type ScheduleFrequencyType = typeof ScheduleFrequency[keyof typeof ScheduleFrequency];

export const WeekDay = {
  MONDAY: 'MONDAY',
  TUESDAY: 'TUESDAY',
  WEDNESDAY: 'WEDNESDAY',
  THURSDAY: 'THURSDAY',
  FRIDAY: 'FRIDAY',
  SATURDAY: 'SATURDAY',
  SUNDAY: 'SUNDAY',
} as const;

export type WeekDayType = typeof WeekDay[keyof typeof WeekDay];

export const QuarterDay = {
  FIRST: 'FIRST',
  MIDDLE: 'MIDDLE',
  LAST: 'LAST',
} as const;

export type QuarterDayType = typeof QuarterDay[keyof typeof QuarterDay];
export interface ScheduledReport {
  scheduled_report_id?: string;
  report_id: string;
  frequency: ScheduleFrequencyType;
  month_day: number | null;
  week_day: WeekDayType | null;
  quarter_day: QuarterDayType | null;
  scheduled_report_recipients: string[];
}
